import ReactDOM from 'react-dom';
import IWidgetConfiguration from '../../../../common/model/IWidgetConfiguration';
import EventContainer from '../../../../common/event/EventContainer';
import CommonEvents from '../../../../common/constants/events';

const widgetFacadeFactory = {
  create(config: IWidgetConfiguration, eventContainer: EventContainer): any {
    return {
      destroy: (): void => {
        eventContainer.emit(CommonEvents.DESTROY);

        ReactDOM.unmountComponentAtNode(document.getElementById(config.containerId) as Element);

        eventContainer.removeAllListeners();
      },

      on: (event: string, callback: () => void): void => {
        eventContainer.on(event, callback);
      },

      onEvery: (callback: (event: string) => void): void => {
        eventContainer.onEvery(callback);
      },
    };
  },
};

export default widgetFacadeFactory;
